import {
  createTimestampValue,
  TimestampValue,
  type TimestampValueOptions
} from "@zyzgroup/core-common";

// localStorage 存储的数据可以跨浏览器会话访问
// localStorage 的范围： 同源（Same Origin） + 浏览器实例，只要域名一样，所有 Tab 共享数据

// 存储量 5MB

// 不会带到 HTTP 请求中，仅位于浏览器端，不与服务端发生通信

export function createLocalStorage(
  key: string | symbol,
  options?: TimestampValueOptions
) {
  const k = typeof key == "string" ? key : key.toString();

  // read
  const getInDom = () => {
    try {
      const fromLocal = window.localStorage.getItem(k);
      if (fromLocal) {
        return JSON.parse(fromLocal);
      }
    } catch (e) {
      // do nothing
    }
    return undefined;
  };

  // write or remove
  const setInDom = (timestampValue: TimestampValue) => {
    try {
      if (typeof timestampValue.value != "undefined") {
        window.localStorage.setItem(k, JSON.stringify(timestampValue));
      } else {
        window.localStorage.removeItem(k);
      }
    } catch (e) {
      // do nothing
    }
  };

  return {
    get: () => createTimestampValue(getInDom(), options).get().value,
    set: (v: any) => setInDom(createTimestampValue(getInDom(), options).set(v))
  };
}

export function clearLocalStorage() {
  window.localStorage.clear();
}
